import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";

@Injectable({ providedIn: 'root' })
export class ImageService {
  constructor(private http: HttpClient) {}

  downloadImage(path: string, onLoadend: (base64data: string) => void) {
    this.http.get(path, { responseType: 'blob' }).subscribe((res: Blob) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64data = reader.result as string;
        onLoadend(base64data);
      };
      reader.readAsDataURL(res);
    });
  }
}
